document.addEventListener('DOMContentLoaded', function() {
  class QuantitySelector {
    constructor(productForm) {
      this.productForm = productForm;
      this.variantId = productForm.dataset.variantId || productForm.querySelector('.product-variant-id')?.value;
      this.addToCartBtn = productForm.querySelector('.add-to-cart-btn');
      this.quantityWrapper = productForm.querySelector('.quantity-selector-wrapper');
      this.quantitySelector = productForm.querySelector('.quantity-selector');
      this.quantityDisplay = productForm.querySelector('.quantity-display');
      this.decreaseBtn = productForm.querySelector('.quantity-decrease');
      this.increaseBtn = productForm.querySelector('.quantity-increase');
      this.cartLinkBtn = productForm.querySelector('.cart-link-btn');
      this.dynamicCheckout = productForm.querySelector('.dynamic-checkout-wrapper');
      
      this.currentQuantity = 0;
      this.isUpdating = false;
      // Track if button was disabled by other scripts
      this.wasDisabledByOtherScript = false;
      
      // Store original button text for stock check
      if (this.addToCartBtn) this.addToCartBtn.dataset.originalText = this.addToCartBtn.textContent;
      
      if (this.addToCartBtn && this.quantityWrapper && this.variantId) {
        this.init();
      }
    }

    // Check if variant is in stock by fetching product data
    async checkVariantStock() {
      try {
        // Get current product handle from URL or form
        const productHandle = window.location.pathname.split('/products/')[1]?.split('?')[0];
        if (!productHandle) return true;

        // Fetch product data with variants
        const response = await fetch(`/products/${productHandle}.js`);
        if (!response.ok) return true;
        
        const product = await response.json();
        
        // Find the current variant
        const variant = product.variants.find(v => String(v.id) === String(this.variantId));
        
        if (variant) {
          // Check if variant is available
          return variant.available;
        }
        
        return true; // Default to available if variant not found
      } catch (error) {
        console.error('Error checking variant stock:', error);
        return true; // Default to available on error
      }
    }

    // Update button state based on stock
    async updateStockState() {
      try {
        const isInStock = await this.checkVariantStock();
        
        if (this.addToCartBtn) {
          if (!isInStock) {
            this.addToCartBtn.disabled = true;
            this.addToCartBtn.textContent = 'Sold Out';
            this.addToCartBtn.classList.add('sold-out');
          } else if (!this.wasDisabledByOtherScript && !this.isUpdating) {
            this.addToCartBtn.disabled = false;
            this.addToCartBtn.textContent = this.addToCartBtn.dataset.originalText || 'Add to Cart';
            this.addToCartBtn.classList.remove('sold-out');
          }
        }
      } catch (error) {
        console.error('Error updating stock state:', error);
      }
    }
    
    init() {
      // Update header cart count on page load
  try {
    const updateInitialHeaderCount = async () => {
      try {
        const response = await fetch('/cart.js');
        if (!response.ok) return;
        
        const cart = await response.json();
        
        const headerCartLink = document.querySelector('.cart_items_custom_qty_bhoopi');
        if (headerCartLink) {
          headerCartLink.textContent = `BAG (${cart.item_count})`;
        }
      } catch (error) {
        console.error('Error updating initial header cart count:', error);
      }
    };
    
    updateInitialHeaderCount();
  } catch (error) {
    console.error('Error setting up initial header cart count:', error);
  }
  
  // Initialize quantity selectors
  try {
        this.checkCartState();
        
        this.addToCartBtn.addEventListener('click', (e) => this.handleAddToCart(e));
        this.decreaseBtn?.addEventListener('click', () => this.decreaseQuantity());
        this.increaseBtn?.addEventListener('click', () => this.increaseQuantity());
        this.cartLinkBtn?.addEventListener('click', () => this.goToCart());
        
        // Listen for cart updates from other parts of the site
        document.addEventListener('cart:updated', () => {
          this.checkCartState();
          this.updateHeaderCartCount();
        });
        // Monitor button disabled state changes from other scripts

        this.setupDisabledStateMonitor();
        this.setupVariantChangeListener();
      } catch (error) {
        console.error('Error initializing QuantitySelector:', error);
      }
    }



     setupDisabledStateMonitor() {

      try {

        if (this.addToCartBtn) {

          // Use MutationObserver to watch for disabled attribute changes

          const observer = new MutationObserver((mutations) => {

            mutations.forEach((mutation) => {

              if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {

                // Check if the disabled state was changed by other scripts (not by our loading state)

                if (!this.isUpdating) {

                  this.wasDisabledByOtherScript = this.addToCartBtn.disabled;

                  console.log('Button disabled state changed by other script:', this.wasDisabledByOtherScript);

                }

              }

            });

          });

          

          observer.observe(this.addToCartBtn, {

            attributes: true,

            attributeFilter: ['disabled']

          });

          

          // Store initial disabled state

          this.wasDisabledByOtherScript = this.addToCartBtn.disabled;

        }

      } catch (error) {

        console.error('Error setting up disabled state monitor:', error);

      }

    }

    
    setupVariantChangeListener() {
      try {
        const variantIdInput = this.productForm.querySelector('.product-variant-id');
        if (variantIdInput) {
          const observer = new MutationObserver(() => {
            try {
              const newVariantId = variantIdInput.value;
              if (newVariantId && newVariantId != this.variantId) {
                console.log('Variant changed from', this.variantId, 'to', newVariantId);
                this.updateVariant(newVariantId);
              }
            } catch (error) {
              console.error('Error in MutationObserver:', error);
            }
          });
          
          observer.observe(variantIdInput, {
            attributes: true,
            attributeFilter: ['value']
          });
          
          let lastValue = variantIdInput.value || '';
          const checkValueChange = () => {
            try {
              const currentValue = variantIdInput.value || '';
              if (currentValue !== lastValue && currentValue !== this.variantId && currentValue !== '') {
                console.log('Variant value changed from', lastValue, 'to', currentValue);
                lastValue = currentValue;
                this.updateVariant(currentValue);
              }
            } catch (error) {
              console.error('Error checking value change:', error);
            }
          };
          
          setInterval(checkValueChange, 500);
        }
        
        const sectionContainer = this.productForm.closest('[data-section-id]');
        if (sectionContainer) {
          const variantInputs = sectionContainer.querySelectorAll('input[name^="options"], select[name^="options"]');
          variantInputs.forEach(input => {
            input.addEventListener('change', () => {
              try {
                console.log('Variant selector changed:', input.name, input.value);
                setTimeout(() => {
                  const currentVariantId = this.productForm.querySelector('.product-variant-id')?.value;
                  if (currentVariantId && currentVariantId != this.variantId) {
                    console.log('Updating variant after selector change:', currentVariantId);
                    this.updateVariant(currentVariantId);
                  }
                }, 200);
              } catch (error) {
                console.error('Error handling variant selector change:', error);
              }
            });
          });
        }
        
        document.addEventListener('variant:change', (event) => {
          try {
            if (event.detail && event.detail.variant && event.detail.variant.id != this.variantId) {
              console.log('Shopify variant:change event:', event.detail.variant.id);
              this.updateVariant(event.detail.variant.id);
            }
          } catch (error) {
            console.error('Error handling variant:change event:', error);
          }
        });
      } catch (error) {
        console.error('Error setting up variant change listener:', error);
      }
    }
    
    updateVariant(newVariantId) {
      try {
        console.log('Updating variant from', this.variantId, 'to', newVariantId);
        
        this.variantId = String(newVariantId);
        this.productForm.dataset.variantId = this.variantId;
        
        if (this.addToCartBtn) {
          this.addToCartBtn.dataset.variantId = this.variantId;
        }
        
        const variantIdInput = this.productForm.querySelector('.product-variant-id');
        if (variantIdInput && variantIdInput.value != this.variantId) {
          variantIdInput.value = this.variantId;
        }
        
        this.setLoading(false);
        this.checkCartState();
        this.updateStockState();
        // After variant update, check if button was disabled by other scripts

        setTimeout(() => {

          if (this.addToCartBtn && this.addToCartBtn.disabled && !this.isUpdating) {

            this.wasDisabledByOtherScript = true;

            console.log('Button disabled after variant change by other script');

          }

        }, 100);
      } catch (error) {
        console.error('Error updating variant:', error);
      }
    }
    
    async checkCartState() {
      try {
        const response = await fetch('/cart.js');
        if (!response.ok) throw new Error('Failed to fetch cart');
        
        const cart = await response.json();
        
        const cartItem = cart.items.find(item => String(item.variant_id) === String(this.variantId));
        const quantity = cartItem ? cartItem.quantity : 0;
        
        this.updateDisplay(quantity);
      } catch (error) {
        console.error('Error checking cart state:', error);
        this.updateDisplay(0);
      }
    }
    
    updateDisplay(quantity) {
      try {
        this.currentQuantity = quantity;
        if (this.quantityDisplay) {
          this.quantityDisplay.textContent = quantity;
        }
        
        if (quantity > 0) {
          this.showQuantitySelector();
        } else {
          this.showAddToCartButton();
        }
        
        if (this.decreaseBtn) {
          this.decreaseBtn.disabled = quantity <= 0;
        }
        this.updateStockState();
      } catch (error) {
        console.error('Error updating display:', error);
      }
    }
    
    showQuantitySelector() {
      try {
        if (this.addToCartBtn) this.addToCartBtn.style.display = 'none';
        if (this.quantityWrapper) this.quantityWrapper.style.display = 'flex';
        this.productForm.classList.add('quantity-selector-active');
      } catch (error) {
        console.error('Error showing quantity selector:', error);
      }
    }
    
    showAddToCartButton() {
      try {
        if (this.addToCartBtn) this.addToCartBtn.style.display = 'block';
        if (this.quantityWrapper) this.quantityWrapper.style.display = 'none';
        this.productForm.classList.remove('quantity-selector-active');
      } catch (error) {
        console.error('Error showing add to cart button:', error);
      }
    }
    
    async handleAddToCart(e) {
      e.preventDefault();
      
      if (this.isUpdating) return;
      
      if (!(await this.checkVariantStock())) {
        this.showError('This product is currently out of stock');
        return;
      }
      
      try {
        const variantIdInput = this.productForm.querySelector('.product-variant-id');
        if (variantIdInput && variantIdInput.value) {
          this.variantId = String(variantIdInput.value);
        }
        
        console.log('Adding to cart, variant ID:', this.variantId);
        
        const form = this.productForm.querySelector('form');
        if (!form) throw new Error('Form not found');
        
        const formData = new FormData(form);
        formData.set('id', this.variantId);
        
        this.setLoading(true);
        
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        
        if (response.ok) {
          const result = await response.json();
          console.log('Added to cart:', result);
          this.updateDisplay(this.currentQuantity + (result.quantity || 1));
          this.dispatchCartUpdated();
        } else {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.message || 'Failed to add to cart');
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        this.showError(error.message || 'Failed to add product to cart');
      } finally {
        this.setLoading(false);
      }
    }
    
    async increaseQuantity() {
      if (this.isUpdating) return;
      await this.updateCartQuantity(this.currentQuantity + 1);
    }
    
    async decreaseQuantity() {
      if (this.isUpdating || this.currentQuantity <= 0) return;
      await this.updateCartQuantity(this.currentQuantity - 1);
    }
    
    async updateCartQuantity(newQuantity) {
      try {
        this.setLoading(true);
        
        const updates = {};
        updates[this.variantId] = newQuantity;
        
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates })
        });
        
        if (response.ok) {
          this.updateDisplay(newQuantity);
          this.dispatchCartUpdated();
        } else {
          throw new Error('Failed to update cart');
        }
      } catch (error) {
        console.error('Error updating cart:', error);
        this.showError('Failed to update cart');
        this.checkCartState();
      } finally {
        this.setLoading(false);
      }
    }
    
    setLoading(loading) {
      try {
        this.isUpdating = loading;
        
        if (loading) {
          this.quantitySelector?.classList.add('loading');
          
          if (this.addToCartBtn) this.addToCartBtn.disabled = true;
          if (this.addToCartBtn) {

            this.addToCartBtn.disabled = true;

          }
        } else {
          this.quantitySelector?.classList.remove('loading');
          if (this.addToCartBtn) this.addToCartBtn.disabled = false;
          if (this.addToCartBtn) {

            // Only enable the button if it wasn't disabled by other scripts

            if (!this.wasDisabledByOtherScript) {

              this.addToCartBtn.disabled = false;

            }

            // If it was disabled by other scripts, leave it disabled

          }
        }
      } catch (error) {
        console.error('Error setting loading state:', error);
      }
    }
    
    goToCart() {
      try {
        window.location.href = '/cart';
        // window.HS_SLIDE_CART_OPEN();
      } catch (error) {
        console.error('Error navigating to cart:', error);
      }
    }
    
    dispatchCartUpdated() {
      try {
        // Update header cart count
        this.updateHeaderCartCount();
        
        // Dispatch custom event for other parts of the site
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } catch (error) {
        console.error('Error dispatching cart updated event:', error);
      }
    }
    
    async updateHeaderCartCount() {
      try {
        const response = await fetch('/cart.js');
        if (!response.ok) throw new Error('Failed to fetch cart');
        
        const cart = await response.json();
        
        // Update header cart count
        const headerCartLink = document.querySelector('.cart_items_custom_qty_bhoopi');
        if (headerCartLink) {
          headerCartLink.textContent = `BAG (${cart.item_count})`;
        }
        
        // Also update any other cart count elements that might exist
        const cartCountElements = document.querySelectorAll('[data-cart-count]');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count;
        });
        
      } catch (error) {
        console.error('Error updating header cart count:', error);
      }
    }
    
    showError(message) {
      try {
        const errorWrapper = this.productForm.querySelector('.product-form__error-message-wrapper');
        const errorMessage = this.productForm.querySelector('.product-form__error-message');
        
        if (errorWrapper && errorMessage) {
          errorMessage.textContent = message || 'An error occurred';
          errorWrapper.hidden = false;
          
          setTimeout(() => {
            errorWrapper.hidden = true;
          }, 5000);
        }
      } catch (error) {
        console.error('Error showing error message:', error);
      }
    }
  }
  
  try {
    const productForms = document.querySelectorAll('product-form');
    productForms.forEach(form => {
      try {
        const variantId = form.dataset.variantId || form.querySelector('.product-variant-id')?.value;
        if (variantId) {
          new QuantitySelector(form);
        }
      } catch (error) {
        console.error('Error initializing individual QuantitySelector:', error);
      }
    });
  } catch (error) {
    console.error('Error initializing QuantitySelectors:', error);
  }
});

document.addEventListener('DOMContentLoaded', function() {
  // Flags to prevent infinite loops
  let isProcessingStars = false;
  let isProcessingAuthorTimestamp = false;
  
  // Handle star rating display modifications
  try {
    const modifyStarRatings = () => {
      if (isProcessingStars) return;
      isProcessingStars = true;
      
      const ratingElements = document.querySelectorAll('.jdgm-rev__rating[data-score]:not([data-processed])');
      
      ratingElements.forEach(rating => {
        try {
          // Count active stars
          const activeStars = rating.querySelectorAll('.jdgm-star.jdgm--on');
          const starCount = activeStars.length;
          
          if (starCount > 0) {
            // Hide all stars
            const allStars = rating.querySelectorAll('.jdgm-star');
            allStars.forEach(star => {
              star.style.display = 'none';
            });
            
            // Show only the first star
            if (allStars.length > 0) {
              allStars[0].style.display = 'inline-block';
              
              // Add star count after the visible star
              const countSpan = document.createElement('span');
              countSpan.textContent = ` ${starCount}`;
              countSpan.className = 'star-count-display';
              countSpan.style.marginLeft = '4px';
              
              // Remove any existing count display
              const existingCount = rating.querySelector('.star-count-display');
              if (existingCount) {
                existingCount.remove();
              }
              
              // Append the count
              rating.appendChild(countSpan);
            }
          }
          
          // Mark as processed
          rating.setAttribute('data-processed', 'true');
        } catch (error) {
          console.error('Error modifying individual star rating:', error);
        }
      });
      
      isProcessingStars = false;
    };
    
    // Handle author and timestamp combination
    const combineAuthorAndTimestamp = () => {
      if (isProcessingAuthorTimestamp) return;
      isProcessingAuthorTimestamp = true;
      
      // Find all review containers that have pics elements and haven't been processed
      const picsElements = document.querySelectorAll('.jdgm-rev__pics:not([data-author-processed])');
      
      picsElements.forEach(picsElement => {
        try {
          // Find the review container (usually parent or ancestor)
          const reviewContainer = picsElement.closest('.jdgm-rev') || picsElement.closest('[class*="review"]') || picsElement.parentElement;
          
          if (reviewContainer) {
            // Find author and timestamp elements within the review container
            const authorWrapper = reviewContainer.querySelector('.jdgm-rev__author-wrapper');
            const timestampElement = reviewContainer.querySelector('.jdgm-rev__timestamp');
            
            if (authorWrapper && timestampElement) {
              // Check if combined div already exists
              let existingCombined = picsElement.nextElementSibling;
              if (existingCombined && existingCombined.classList.contains('jdgm-rev__author-timestamp-combined')) {
                existingCombined.remove(); // Remove existing combined div
              }
              
              // Create new combined div
              const combinedDiv = document.createElement('div');
              combinedDiv.className = 'jdgm-rev__author-timestamp-combined';
              combinedDiv.style.marginTop = '8px';
              combinedDiv.style.display = 'flex';
              combinedDiv.style.alignItems = 'center';
              combinedDiv.style.gap = '10px';
              combinedDiv.style.fontSize = '14px';
              combinedDiv.style.color = '#666';
              
              // Clone author wrapper
              const clonedAuthor = authorWrapper.cloneNode(true);
              
              // Clone timestamp
              const clonedTimestamp = timestampElement.cloneNode(true);
              
              // Append both to combined div
              combinedDiv.appendChild(clonedAuthor);
              combinedDiv.appendChild(clonedTimestamp);
              
              // Insert after pics element
              picsElement.parentNode.insertBefore(combinedDiv, picsElement.nextSibling);
              
              // Hide original elements
              authorWrapper.style.display = 'none';
              timestampElement.style.display = 'none';
            }
          }
          
          // Mark as processed
          picsElement.setAttribute('data-author-processed', 'true');
        } catch (error) {
          console.error('Error combining author and timestamp for individual review:', error);
        }
      });
      
      isProcessingAuthorTimestamp = false;
    };
    
    // Run modifications on page load
    modifyStarRatings();
    combineAuthorAndTimestamp();
    
    // Also run when new content is loaded (for AJAX/dynamic content)
    const observer = new MutationObserver((mutations) => {
      let shouldUpdateStars = false;
      let shouldUpdateAuthorTimestamp = false;
      
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) { // Element node
              // Ignore our own created elements
              if (node.classList?.contains('star-count-display') || 
                  node.classList?.contains('jdgm-rev__author-timestamp-combined')) {
                return;
              }
              
              // Check for new star rating elements
              if (node.classList?.contains('jdgm-rev__rating') || 
                  node.querySelector?.('.jdgm-rev__rating:not([data-processed])')) {
                shouldUpdateStars = true;
              }
              
              // Check for new author/timestamp elements
              if (node.classList?.contains('jdgm-rev__pics') || 
                  node.querySelector?.('.jdgm-rev__pics:not([data-author-processed])')) {
                shouldUpdateAuthorTimestamp = true;
              }
            }
          });
        }
      });
      
      if ((shouldUpdateStars || shouldUpdateAuthorTimestamp) && !isProcessingStars && !isProcessingAuthorTimestamp) {
        setTimeout(() => {
          if (shouldUpdateStars) modifyStarRatings();
          if (shouldUpdateAuthorTimestamp) combineAuthorAndTimestamp();
        }, 100);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
  } catch (error) {
    console.error('Error setting up review modifications:', error);
  }
});

// Wait for the DOM to be fully loaded
document.addEventListener('DOMContentLoaded', function() {
    // Add a small delay to ensure all elements are rendered
    setTimeout(function() {
        // Count the collection card grid divs inside wishlist grid
        const collectionCards = document.querySelectorAll('.wishlist-grid .collection-card-grid');
        const count = collectionCards.length;
        
        // Find the target span element
        const countSpan = document.querySelector('span.wishlist-heading-existswith-wishlist-counts-number');
        
        // Debug logging
        console.log('Collection cards found:', collectionCards);
        console.log('Count:', count);
        console.log('Target span element:', countSpan);
        
        // Append the count to the span if it exists
        if (countSpan) {
            // Clear any existing content first
            countSpan.innerHTML = '';
            // Set the count as text content
            countSpan.textContent = count.toString();
            console.log(`Wishlist count updated: ${count} items found`);

            if (count == 0){
              const emptyList1 = document.querySelector(".wishlist-heading-existswith-wishlist-counts");
              emptyList1.style.display = "none";
      console.log('dddddwwww')
            }

            else {
               const emptyList1 = document.querySelector(".wishlist-heading-existswith-wishlist-counts");
              emptyList1.style.display = "flex";
      console.log('dddddwwww')
            }
        } else {
            console.warn('Target span element not found: span.wishlist-heading-existswith-wishlist-counts-number');
            // Try alternative selectors
            const altSpan1 = document.querySelector('.wishlist-heading-existswith-wishlist-counts-number');
            const altSpan2 = document.querySelector('[class*="wishlist-counts-number"]');
            console.log('Alternative span 1:', altSpan1);
            console.log('Alternative span 2:', altSpan2);
        }
    }, 1000); // 1000ms delay
});

// Alternative approach with MutationObserver (for dynamically loaded content)
function updateWishlistCount() {
    const collectionCards = document.querySelectorAll('.wishlist-grid .collection-card-grid');
    const count = collectionCards.length;
    const countSpan = document.querySelector('span.wishlist-heading-existswith-wishlist-counts-number');
    
    if (countSpan && count >= 0) {
        countSpan.innerHTML = '';
        countSpan.textContent = count.toString();
        console.log(`Wishlist count updated: ${count} items`);
        return true;
    }
    return false;
}

// Try multiple times with different approaches
let attempts = 0;
const maxAttempts = 10;

function tryUpdateCount() {
    attempts++;
    if (updateWishlistCount() || attempts >= maxAttempts) {
        return;
    }
    // Try again after a short delay
    setTimeout(tryUpdateCount, 200);
}

// Start trying after DOM is loaded
document.addEventListener('DOMContentLoaded', tryUpdateCount);

// Also try when window is fully loaded
window.addEventListener('load', tryUpdateCount);

document.addEventListener('DOMContentLoaded', function() {
    // Function to reload the entire quick-add script inline
    function reloadQuickAddScript() {
        console.log('Reloading quick-add script...');
        
        // First, try to clean up existing custom element (though it can't be truly undefined)
        if (customElements.get('quick-add-modal')) {
            console.log('Quick-add-modal already exists, forcing re-execution...');
        }
        
        // Execute the entire quick-add script content
        try {
            // The complete quick-add.js script content
            if (!customElements.get('quick-add-modal')) {
                customElements.define(
                    'quick-add-modal',
                    class QuickAddModal extends ModalDialog {
                        constructor() {
                            super();
                            this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

                            this.addEventListener('product-info:loaded', ({ target }) => {
                                target.addPreProcessCallback(this.preprocessHTML.bind(this));
                            });
                        }

                        hide(preventFocus = false) {
                            const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                            if (cartNotification) cartNotification.setActiveElement(this.openedBy);
                            this.modalContent.innerHTML = '';

                            if (preventFocus) this.openedBy = null;
                            super.hide();
                        }

                        show(opener) {
                            opener.setAttribute('aria-disabled', true);
                            opener.classList.add('loading');
                            opener.querySelector('.loading__spinner').classList.remove('hidden');

                            fetch(opener.getAttribute('data-product-url'))
                                .then((response) => response.text())
                                .then((responseText) => {
                                    const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                                    const productElement = responseHTML.querySelector('product-info');

                                    this.preprocessHTML(productElement);
                                    HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

                                    if (window.Shopify && Shopify.PaymentButton) {
                                        Shopify.PaymentButton.init();
                                    }
                                    if (window.ProductModel) window.ProductModel.loadShopifyXR();

                                    super.show(opener);
                                })
                                .finally(() => {
                                    opener.removeAttribute('aria-disabled');
                                    opener.classList.remove('loading');
                                    opener.querySelector('.loading__spinner').classList.add('hidden');
                                });
                        }

                        preprocessHTML(productElement) {
                            productElement.classList.forEach((classApplied) => {
                                if (classApplied.startsWith('color-') || classApplied === 'gradient')
                                    this.modalContent.classList.add(classApplied);
                            });
                            this.preventDuplicatedIDs(productElement);
                            this.removeDOMElements(productElement);
                            this.removeGalleryListSemantic(productElement);
                            this.updateImageSizes(productElement);
                            this.preventVariantURLSwitching(productElement);
                        }

                        preventVariantURLSwitching(productElement) {
                            productElement.setAttribute('data-update-url', 'false');
                        }

                        removeDOMElements(productElement) {
                            const pickupAvailability = productElement.querySelector('pickup-availability');
                            if (pickupAvailability) pickupAvailability.remove();

                            const productModal = productElement.querySelector('product-modal');
                            if (productModal) productModal.remove();

                            const modalDialog = productElement.querySelectorAll('modal-dialog');
                            if (modalDialog) modalDialog.forEach((modal) => modal.remove());
                        }

                        preventDuplicatedIDs(productElement) {
                            const sectionId = productElement.dataset.section;

                            const oldId = sectionId;
                            const newId = `quickadd-${sectionId}`;
                            productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
                            Array.from(productElement.attributes).forEach((attribute) => {
                                if (attribute.value.includes(oldId)) {
                                    productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
                                }
                            });

                            productElement.dataset.originalSection = sectionId;
                        }

                        removeGalleryListSemantic(productElement) {
                            const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
                            if (!galleryList) return;

                            galleryList.setAttribute('role', 'presentation');
                            galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
                        }

                        updateImageSizes(productElement) {
                            const product = productElement.querySelector('.product');
                            const desktopColumns = product?.classList.contains('product--columns');
                            if (!desktopColumns) return;

                            const mediaImages = product.querySelectorAll('.product__media img');
                            if (!mediaImages.length) return;

                            let mediaImageSizes =
                                '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

                            if (product.classList.contains('product--medium')) {
                                mediaImageSizes = mediaImageSizes.replace('715px', '605px');
                            } else if (product.classList.contains('product--small')) {
                                mediaImageSizes = mediaImageSizes.replace('715px', '495px');
                            }

                            mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
                        }
                    }
                );
            }
            
            console.log('Quick-add script reloaded successfully');
            
            // Force re-scan for new quick-add elements in the drawer
            setTimeout(() => {
                const drawer = document.querySelector('.wishlist_product_drawer_vhoose_product_bhoopsi.active');
                if (drawer) {
                    const quickAddElements = drawer.querySelectorAll('quick-add-modal');
                    const quickAddButtons = drawer.querySelectorAll('[data-product-url]');
                    console.log(`Found ${quickAddElements.length} quick-add modals and ${quickAddButtons.length} buttons in drawer`);
                    
                    // Ensure all quick-add elements are properly connected
                    quickAddElements.forEach(element => {
                        if (!element.isConnected) {
                            console.log('Reconnecting quick-add element...');
                        }
                    });
                }
            }, 100);
            
        } catch (error) {
            console.error('Error reloading quick-add script:', error);
        }
    }
    
    // Add a small delay to ensure all elements are rendered
    setTimeout(function() {
       setTimeout(function() {
                            reloadQuickAddScript();
                        }, 1000); // 1 second delay
        document.addEventListener('click', function(e) {
            // Check if clicked element or its parent has the wishlist button class
            const wishlistButton = e.target.closest('.this_is_wishlist_add_to_cart_custom_bhoopi');
            
            if (wishlistButton) {
                const parent = wishlistButton.closest('.collection-card-grid.ffff');
                if (parent) {
                    const drawer = parent.querySelector('.wishlist_product_drawer_vhoose_product_bhoopsi');
                    if (drawer) {
                        drawer.classList.add('active');
                        console.log('Active class added successfully');
                        
                        // Reload quick-add script 1 second after drawer opens
                       
                        
                    } else {
                        console.log('Drawer not found');
                    }
                } else {
                    console.log('Parent not found');
                }
            }
        });
    }, 2000); // 2 second delay for initial setup
});

// Configuration
const textArray = [
  "I am looking for green tshirt...",
  "I am looking for pink kurta...",
  "I am looking for white pant...",
  "Black jeans under 1500rs...",
  "Shirts above 1000rs..."
];
const typingDelay = 100;
const erasingDelay = 50;
const newTextDelay = 2000;

// Typewriter function factory
function createTypewriter(selector) {
  const searchInput = document.querySelector(selector);
  if (!searchInput) return; // Exit if element doesn't exist
  
  let textArrayIndex = 0;
  let charIndex = 0;

  function type() {
    if (charIndex < textArray[textArrayIndex].length) {
      searchInput.setAttribute(
        "placeholder",
        textArray[textArrayIndex].substring(0, charIndex + 1)
      );
      charIndex++;
      setTimeout(type, typingDelay);
    } else {
      setTimeout(erase, newTextDelay);
    }
  }

  function erase() {
    if (charIndex > 0) {
      searchInput.setAttribute(
        "placeholder",
        textArray[textArrayIndex].substring(0, charIndex - 1)
      );
      charIndex--;
      setTimeout(erase, erasingDelay);
    } else {
      textArrayIndex = (textArrayIndex + 1) % textArray.length;
      setTimeout(type, typingDelay + 1100);
    }
  }

  // Start the typewriter effect
  if (textArray.length) {
    setTimeout(type, newTextDelay + 250);
  }
}

// Initialize typewriter for both inputs when DOM is ready
document.addEventListener("DOMContentLoaded", function () {
  // First input
  createTypewriter("#Search-In-Template");
  
  // Second input
  createTypewriter(".headsebinpt input[name='q']");

  document.addEventListener('click', function(event) {
            const detailsElements = document.querySelectorAll('details[open]');
            
            detailsElements.forEach(function(details) {
                // Check if the clicked element is outside the details element
                if (!details.contains(event.target)) {
                    details.removeAttribute('open');
                }
           });
});

});








function isMobile() {
    return window.innerWidth < 768;
  }
  function isDesktop() {
    return window.innerWidth >= 768;
  }
  function getCurrentPage() {
    const currentPath = window.location.pathname;
    if (currentPath.includes('/account/addresses')) {
      return 'address';
    } else if (currentPath.includes('/account')) {
      return 'account';
    }
    return 'account';
  }
  function getActiveTab() {
    const currentPage = getCurrentPage();
    const storedTab = localStorage.getItem('activeAccountTab');
    
    if (currentPage === 'address') {
      return 'edit-address-tab';
    } else if (storedTab && currentPage === 'account') {
      return storedTab;
    } else if (isMobile() && currentPage === 'account' && !storedTab) {
      // For mobile on account page without stored tab, return null (no active tab)
      return null;
    }
    
    return 'orders-tab';
  }
  function setActiveTab(tabId) {
    localStorage.setItem('activeAccountTab', tabId);
    document.querySelectorAll('.tab-link').forEach(el => el.classList.remove('active'));
    document.querySelectorAll('.account-tab-content').forEach(el => el.classList.remove('active'));
    const activeTabLink = document.querySelector(`[data-tab="${tabId}"]`);
    const activeTabContent = document.getElementById(tabId);
    
    if (activeTabLink) {
      activeTabLink.classList.add('active');
    }
    
    if (activeTabContent) {
      activeTabContent.classList.add('active');
    }
  }
  document.addEventListener('DOMContentLoaded', function() {
    // If mobile and on account page, clear localStorage and don't activate any tab (only on page load)
    if (isMobile() && getCurrentPage() === 'account') {
      // Check if this is a fresh page load (not from tab click)
      const isFromTabClick = sessionStorage.getItem('tabClicked');
      if (!isFromTabClick) {
        localStorage.removeItem('activeAccountTab');
        return;
      } else {
        // Clear the flag after using it
        sessionStorage.removeItem('tabClicked');
      }
    }
    
    const activeTab = getActiveTab();
    
    // Only set active tab if activeTab is not null
    if (activeTab) {
      if (isDesktop()) {
        setActiveTab(activeTab);
      } else {
        setActiveTab(activeTab);
      }
    }
    
    const customAccountLinks = document.querySelectorAll('a.custom_acount_afer_login_bs_bhoospib');
    customAccountLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        localStorage.removeItem('activeAccountTab');
      });
    });
  });
  document.querySelectorAll('.tab-link').forEach(tab => {
    tab.addEventListener('click', function(e) {
      const tabId = this.dataset.tab;
      const pageType = this.dataset.page;
      const url = this.dataset.url;
      
      // Set flag to indicate this is a tab click
      sessionStorage.setItem('tabClicked', 'true');
      
      if (isMobile() && url) {
        localStorage.setItem('activeAccountTab', tabId);
        window.location.href = url;
        return;
      }
      if (url) {
        e.preventDefault();
        localStorage.setItem('activeAccountTab', tabId);
        window.location.href = url;
      } else {
        e.preventDefault();
        setActiveTab(tabId);  
      }
    });
  });
  document.addEventListener('click', function(e) {
    if (e.target.matches('a.custom_acount_afer_login_bs_bhoospib') || e.target.closest('a.custom_acount_afer_login_bs_bhoospib')) {
      localStorage.removeItem('activeAccountTab');
    }
  });
  
  document.body.addEventListener('click', function(e) {
    if (e.target.matches('a.custom_acount_afer_login_bs_bhoospib') || e.target.closest('a.custom_acount_afer_login_bs_bhoospib')) {
      localStorage.removeItem('activeAccountTab');
    }
  });
  window.addEventListener('beforeunload', function() {
    const currentPath = window.location.pathname;
    if (!currentPath.includes('/account')) {
      localStorage.removeItem('activeAccountTab');
    }
  });







  window.addEventListener('load', function() {
  const wishList_id = document.getElementById('wishlist');
  if(wishList_id)
    wishList_id.style.opacity = '1';
});

// window.addEventListener('load', function() {
//    if (window.location.pathname === '/account') {
//        history.pushState(null, null, location.href);
//        history.pushState(null, null, location.href);
//        window.addEventListener('popstate', function() {
//            history.pushState(null, null, location.href);
//            history.pushState(null, null, location.href);
//        });
//    }
// });






document.addEventListener('DOMContentLoaded', function() {
  
  function updateSingleButton(input) {
    const currentQty = parseInt(input.value);
    const plusBtn = input.parentElement.querySelector('button[name="plus"]');
    const maxStock = parseInt(plusBtn.value); // Get available stock from button value
    
    if (currentQty >= maxStock) {
      plusBtn.disabled = true;
      plusBtn.style.opacity = '0.5';
      plusBtn.style.cursor = 'not-allowed';
    } else {
      plusBtn.disabled = false;
      plusBtn.style.opacity = '1';
      plusBtn.style.cursor = 'pointer';
    }
  }

  function updateAllButtons() {
    const inputs = document.querySelectorAll('.quantity__input[data-quantity-variant-id]');
    inputs.forEach(input => {
      updateSingleButton(input);
    });
  }

  // Run on page load
  updateAllButtons();

  // Run when buttons clicked - ONLY update the specific item
  document.addEventListener('click', function(e) {
    if (e.target.closest('button[name="plus"]') || e.target.closest('button[name="minus"]')) {
      const quantityContainer = e.target.closest('quantity-input');
      const input = quantityContainer.querySelector('.quantity__input');
      setTimeout(() => updateSingleButton(input), 100);
    }
  });

  // Run when input changes directly - ONLY update that specific input
  document.addEventListener('input', function(e) {
    if (e.target.matches('.quantity__input')) {
      updateSingleButton(e.target);
    }
  });





});








(function () {
  // Hook fetch
  const originalFetch = window.fetch;
  window.fetch = async function () {
    const response = await originalFetch.apply(this, arguments);

    try {
      const url = arguments[0];
      if (typeof url === "string" && (url.includes("/cart/change") || url.includes("/cart/update"))) {
        // Check updated cart
        response.clone().json().then(cart => {
          if (cart.item_count === 0) {
            handleEmptyCart();
          }
        });
      }
    } catch (e) {
      console.warn("Cart hook error:", e);
    }

    return response;
  };

  // Hook XHR (for themes using XMLHttpRequest)
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.addEventListener("load", function () {
      if (url.includes("/cart/change") || url.includes("/cart/update")) {
        try {
          const cart = JSON.parse(this.responseText);
          if (cart.item_count === 0) {
            handleEmptyCart();
          }
        } catch (e) {}
      }
    });
    return origOpen.apply(this, arguments);
  };

  // Function: what to do when cart is empty
  function handleEmptyCart() {
    document.querySelector(".custom_cart_bhoopi_new_layout_bhoopi_innner_heading_bag")?.style.setProperty("display", "none", "important");
    document.querySelector(".cart-discputn-bs-bhoopi-clau")?.style.setProperty("display", "none", "important");
    document.querySelector(".custom_cart_bhoopi_new_layout_bhoopi_cart_left")?.style.setProperty("width", "100%", "important");
    document.querySelector(".custom_cart_bhoopi_new_layout_bhoopi_cart_right")?.style.setProperty("display", "none", "important");
  }
})();

document.addEventListener("DOMContentLoaded", function () {
//  jQuery(function ($) {
//     // strict match for https://hob.fashion/account (allow optional trailing slash)
//     var onAccount = (location.origin === 'https://hob.fashion') &&
//                     (location.pathname === '/account' || location.pathname === '/account/');

//     if (onAccount && $(window).width() > 768) {
//       $('.account-tab-content.make_active_when_load_only_in_desktop').addClass('active');


//          $('.account-tab-content.main-acount-page-opacity-none').removeClass('active');
//          $('li.tab-link[data-tab="edit-address-tab"]').removeClass('active');


        
//       // $('li.tab-link[data-tab="orders-tab"]').addClass('active');
//     }
//   });
});


window.addEventListener('DOMContentLoaded', function() {

   // Get elements
        const bilivers_club_from_pop_bhoopi__termsLabel = document.getElementById('bilivers_club_from_pop_bhoopi__termsLabel');
        const bilivers_club_from_pop_bhoopi__modalOverlay = document.getElementById('bilivers_club_from_pop_bhoopi__modalOverlay');
        const bilivers_club_from_pop_bhoopi__modalContent = document.getElementById('bilivers_club_from_pop_bhoopi__modalContent');
        const bilivers_club_from_pop_bhoopi__closeBtn = document.getElementById('bilivers_club_from_pop_bhoopi__closeBtn');

        // Function to open modal
        function bilivers_club_from_pop_bhoopi__openModal() {
            bilivers_club_from_pop_bhoopi__modalOverlay.classList.add('active');
            document.body.classList.add('bilivers_club_from_pop_bhoopi__modal-open');
        }

        // Function to close modal
        function bilivers_club_from_pop_bhoopi__closeModal() {
            bilivers_club_from_pop_bhoopi__modalOverlay.classList.remove('active');
            document.body.classList.remove('bilivers_club_from_pop_bhoopi__modal-open');
        }

        // Event listeners
        bilivers_club_from_pop_bhoopi__termsLabel.addEventListener('click', bilivers_club_from_pop_bhoopi__openModal);
        bilivers_club_from_pop_bhoopi__closeBtn.addEventListener('click', bilivers_club_from_pop_bhoopi__closeModal);

        // Close modal when clicking outside the content
        bilivers_club_from_pop_bhoopi__modalOverlay.addEventListener('click', function(e) {
            if (e.target === bilivers_club_from_pop_bhoopi__modalOverlay) {
                bilivers_club_from_pop_bhoopi__closeModal();
            }
        });

        // Close modal with Escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && bilivers_club_from_pop_bhoopi__modalOverlay.classList.contains('active')) {
                bilivers_club_from_pop_bhoopi__closeModal();
            }
        });

        // Prevent modal content clicks from closing the modal
        bilivers_club_from_pop_bhoopi__modalContent.addEventListener('click', function(e) {
            e.stopPropagation();
        });


        // Get the date input element
const dateInput = document.getElementById('contact-dob-ayllmaitmqwj6l20wraigenblock6feecf8phg4kx');

// Check if element exists
if (!dateInput) {
    console.error('Date input element not found. Please check the element ID.');
} else {
    console.log('Date input element found successfully!');

    // Function to set the maximum allowed date (18 years ago from today)
    function setMaxDate() {
        const today = new Date();
        const eighteenYearsAgo = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
        
        // Format date as YYYY-MM-DD for the input's max attribute
        const maxDate = eighteenYearsAgo.toISOString().split('T')[0];
        
        // Set the max attribute
        dateInput.setAttribute('max', maxDate);
        console.log('Max date set to:', maxDate);
    }

    // Function to validate the selected date
    function validateAge() {
        if (!dateInput.value) return true; // Allow empty values
        
        const selectedDate = new Date(dateInput.value);
        const today = new Date();
        const eighteenYearsAgo = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
        
        if (selectedDate > eighteenYearsAgo) {
            alert('You must be at least 18 years old.');
            dateInput.value = ''; // Clear the invalid date
            return false;
        }
        return true;
    }

    // Set the maximum date
    setMaxDate();

    // Add event listener to validate on date change
    dateInput.addEventListener('change', validateAge);

    // Optional: Also validate on input (as user types)
    dateInput.addEventListener('input', validateAge);
    
    console.log('Age restriction script applied successfully!');
}



const phoneInputb = document.getElementById("contact-mobile-ayllmaitmqwj6l20wraigenblock6feecf8phg4kx");
phoneInput.addEventListener("input", function () {
  // Remove anything that is not a number
  this.value = this.value.replace(/\D/g, '');

  // Limit to 10 digits
  if (this.value.length > 10) {
    this.value = this.value.slice(0, 10);
  }
});


  });






window.addEventListener('DOMContentLoaded', function() {
    const searchInput = document.getElementById('Search-In-Template');
    if (searchInput) {
        searchInput.focus();
        console.log('search active <<<<<<<<<<<<<<<<<<<<>>>>>>>>>>>>>>>>>>>>>')
    }
    console.log('search CHECK <<<<<<<<<<<<<<<<<<<<>>>>>>>>>>>>>>>>>>>>>')
});